import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import api, { formatPriceRange, resolveAsset } from "@/lib/api";
import ScrollCue from "@/components/site/ScrollCue";

const HomeUpcomingStrip = ({ enabled = true }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!enabled) return;
        api.get("/bikes?is_upcoming=true&limit=8").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
    }, [enabled]);

    if (!enabled || items.length === 0) return null;

    return (
        <section className="py-12 sm:py-16 bg-gradient-to-b from-amber-50/80 to-white border-t border-amber-100/80" data-testid="home-upcoming-strip">
            <div className="container-x">
                <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
                    <div>
                        <p className="text-[11px] font-semibold text-amber-700 tracking-wide uppercase flex items-center gap-1.5">
                            <Sparkles size={14} /> Coming soon
                        </p>
                        <h2 className="font-display text-2xl sm:text-3xl text-[#0A2540] mt-2">Register interest early</h2>
                        <p className="text-sm text-zinc-500 mt-1">Pre-book launches arriving at Servall outlets.</p>
                    </div>
                    <Link to="/bikes?is_upcoming=true" className="text-sm font-semibold text-[#E31837] hover:underline inline-flex items-center gap-1">
                        View all upcoming <ArrowRight size={14} />
                    </Link>
                </div>
                <ScrollCue className="flex gap-4 pb-2 snap-x">
                    {items.map((b, i) => (
                        <motion.div
                            key={b.id}
                            initial={{ opacity: 0, x: 16 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.04 }}
                            className="snap-start shrink-0 w-[240px] sm:w-[260px] bike-card overflow-hidden"
                        >
                            <Link to={`/bikes/${b.id}`} className="block group">
                                <div className="aspect-[4/3] bg-[#f3f4f6] overflow-hidden relative">
                                    <img src={resolveAsset(b.image)} alt={b.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                                    <span className="absolute top-2 left-2 text-[9px] font-black uppercase bg-amber-500 text-white px-2 py-0.5 rounded-full">Coming soon</span>
                                </div>
                                <div className="p-3">
                                    <p className="text-[10px] uppercase text-zinc-400">{b.brand}</p>
                                    <p className="font-display font-bold text-sm leading-tight mt-0.5">{b.name}</p>
                                    <p className="text-xs text-[#E31837] font-semibold mt-1">{formatPriceRange(b.price_min, b.price_max)}</p>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </ScrollCue>
            </div>
        </section>
    );
};

export default HomeUpcomingStrip;
